import { getPricingTierForPlanCode } from "../Pricing/pricingTierOptions";

export interface OnboardingPlanStoreLimitLike {
  code?: string | null;
  rules?: Record<string, unknown> | null;
}

export interface OnboardingPlanAvailability {
  allowed: boolean;
  storeLimit: number | null;
}

const toPositiveInteger = (value: unknown): number | null => {
  const parsed =
    typeof value === "number" || typeof value === "string"
      ? Number(value)
      : NaN;

  return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
};

const normalizePlanCode = (value: unknown): string =>
  typeof value === "string" ? value.trim().toUpperCase() : "";

const resolveCatalogStoreLimit = (planCode: string): number | null => {
  const group = planCode.startsWith("TEAM") || planCode === "PRO" ? "team" : "solo";
  const tier = getPricingTierForPlanCode(group, planCode);
  return toPositiveInteger(tier?.storeConnections.monthly);
};

export const resolveOnboardingPlanStoreLimit = (
  plan?: OnboardingPlanStoreLimitLike | null,
): number | null =>
  toPositiveInteger(plan?.rules?.ecommerceStoreLimit) ??
  resolveCatalogStoreLimit(normalizePlanCode(plan?.code)) ??
  null;

export const resolveOnboardingPlanAvailability = (
  plan: OnboardingPlanStoreLimitLike | null | undefined,
  connectedStoreCount: number,
): OnboardingPlanAvailability => {
  const storeLimit = resolveOnboardingPlanStoreLimit(plan);

  return {
    allowed: storeLimit === null || connectedStoreCount <= storeLimit,
    storeLimit,
  };
};
